/* eslint-disable import/no-unresolved */
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { GlobalStyle } from "./shared/styles/GlobalStyles"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>
)
